(function () {
  'use strict';
  if (window.STMNPatches) return;
  var busy = false;
  function picker() { return document.querySelector('[data-stmn-patch-picker]'); }
  function choices() { var p = picker(); return p ? Array.from(p.querySelectorAll('[data-stmn-patch-choice][aria-pressed="true"]')) : []; }
  function quantity() { return Math.max(1, parseInt(document.getElementById('mp-qty-input')?.value, 10) || 1); }
  function money(cents) {
    var p = picker();
    return new Intl.NumberFormat(p?.dataset.locale || 'it', {style: 'currency', currency: p?.dataset.currency || 'EUR'}).format(cents / 100);
  }
  function syncDynamicCheckout(selected, qty) {
    var form = document.getElementById('mp-product-form');
    var container = form?.querySelector('[data-stmn-patch-checkout-items]');
    if (!container) return;
    var variant = window._mp?.variant;
    var variantInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (variantInput && variant) variantInput.value = variant.id;
    if (qtyInput) qtyInput.value = qty;
    var signature = JSON.stringify([qty, selected.map(function (option) { return option.dataset.variant; })]);
    if (container.dataset.selection !== signature) {
      var fields = document.createDocumentFragment();
      selected.forEach(function (option, index) {
        // Shopify's native accelerated checkout indexes additional products from 1.
        [['id', option.dataset.variant], ['quantity', qty]].forEach(function (entry) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'shopify-additional-items[' + (index + 1) + '][' + entry[0] + ']';
          input.value = entry[1];
          fields.appendChild(input);
        });
      });
      container.replaceChildren(fields);
      container.dataset.selection = signature;
    }
    var wrapper = document.getElementById('mp-dynamic-checkout');
    if (wrapper) wrapper.inert = busy;
  }
  function refresh() {
    var p = picker(); if (!p) return;
    var selected = choices(), qty = quantity();
    var total = selected.reduce(function (sum, option) { return sum + Number(option.dataset.price); }, 0) * qty;
    p.querySelector('[data-patch-summary]').textContent = selected.length ? selected.map(function (option) { return option.dataset.name; }).join(' + ') + ' · +' + money(total) + (qty > 1 ? ' ' + ((window.STMN_I18N||{})['patches.per_backpacks']||'per {n} zaini').replace('{n}', qty) : '') : ((window.STMN_I18N||{})['patches.none_selected']||'Nessuna patch selezionata');
    var available = !!(window._mp?.variant?.available);
    syncDynamicCheckout(selected, qty);
    var label = document.getElementById('mp-atc-text');
    if (label && !busy && available) label.textContent = selected.length ? ((window.STMN_I18N||{})['patches.add_backpack_patch']||'Aggiungi zaino + patch') : window._mpAddText || ((window.STMN_I18N||{})['common.add_to_cart']||'Aggiungi al carrello');
  }
  function read(response) {
    return response.json().then(function (data) {
      if (!response.ok) throw new Error(data.description || data.message || ((window.STMN_I18N||{})['patches.add_error']||'Non è stato possibile aggiungere gli articoli.'));
      return data;
    });
  }
  function add(toCheckout) {
    var p = picker(), variant = window._mp?.variant;
    if (!p || busy || !variant?.available) return Promise.resolve(false);
    var qty = quantity(), items = [{id: Number(variant.id), quantity: qty}].concat(choices().map(function (option) { return {id: Number(option.dataset.variant), quantity: qty}; }));
    var root = (p.dataset.root || '/').replace(/\/?$/, '/');
    var controls = Array.from(document.querySelectorAll('#mp-atc-btn,#mp-sticky-btn,#mp-qty-input,.mp__qty-btn,[data-stmn-patch-choice]'));
    var disabled = controls.map(function (button) { return button.disabled; });
    var error = p.querySelector('[role="alert"]');
    error.hidden = true; busy = true;
    controls.forEach(function (button) { button.disabled = true; });
    refresh();
    document.getElementById('mp-atc-text').textContent = ((window.STMN_I18N||{})['patches.adding']||'Aggiunta…');
    return fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: items})})
      .then(read).then(function () {
        document.dispatchEvent(new CustomEvent('stmn:cart-changed'));
        // A failed badge refresh must not suggest repeating an already successful addition.
        return fetch(root + 'cart.js').then(read).then(function (cart) {
          document.querySelectorAll('[data-cart-count],.cart-count-bubble span').forEach(function (node) { node.textContent = cart.item_count; node.removeAttribute('hidden'); });
        }).catch(function () {});
      }).then(function () {
        if (toCheckout) { location.href = root + 'checkout'; return true; }
        if (typeof window.mpCartDrawerOpen === 'function') window.mpCartDrawerOpen();
        else location.href = root + 'cart';
        return true;
      }).catch(function (e) {
        error.textContent = e.message || ((window.STMN_I18N||{})['patches.add_error_retry']||'Non è stato possibile aggiungere gli articoli. Riprova.');
        error.hidden = false;
        return false;
      }).finally(function () {
        busy = false;
        controls.forEach(function (button, index) { button.disabled = disabled[index]; });
        refresh();
      });
  }
  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-stmn-patch-choice]');
    if (option && !option.disabled && !busy) {
      var selected = option.getAttribute('aria-pressed') !== 'true';
      option.setAttribute('aria-pressed', String(selected));
      option.setAttribute('aria-label', (selected ? ((window.STMN_I18N||{})['patches.remove_patch']||'Rimuovi patch {name}') : ((window.STMN_I18N||{})['patches.select_patch']||'Seleziona patch {name}')).replace('{name}', option.dataset.name));
      option.querySelector('[data-patch-state]').textContent = selected ? ((window.STMN_I18N||{})['patches.state_selected']||'✓ Selezionata') : ((window.STMN_I18N||{})['patches.state_add']||'+ Aggiungi');
      refresh();
    } else if (event.target.closest('.mp__qty-btn')) refresh();
  });
  document.addEventListener('change', refresh);
  document.addEventListener('input', function (event) {
    if (event.target.id === 'mp-qty-input') refresh();
  });
  document.addEventListener('stmn:variant-changed', refresh);
  document.addEventListener('shopify:section:load', refresh);
  window.STMNPatches = {hasPicker: function () { return !!picker(); }, add: add, refresh: refresh};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
